import { Modal, Paper, Slide } from '@material-ui/core'
import React, { useCallback } from 'react'
import { FileWithPath, useDropzone } from 'react-dropzone'

import UploadIcon from '../../assets/icons/upload.svg'
import { getDirection, getTranslate } from '../../localization'
import { ImageProps } from '../UploadBox/ImageBox'
import ImageBoxSkeleton from '../UploadBox/ImageBox.skeleton'
import ImageBox, { FileStatus } from './ImageBox'
import useStyles from './styles/UploadFileModal.styles'

interface UploadFileModalProps {
  isOpen: boolean
  onClose: () => void
  multi?: boolean
  images: ImageProps[]
  setImages: React.Dispatch<React.SetStateAction<ImageProps[]>>
  onUpload: (img: ImageProps) => void
  onDelete: (img: ImageProps) => void
  loading: boolean
}
const UploadFileModal: React.FC<UploadFileModalProps> = ({
  isOpen,
  onClose,
  multi,
  images,
  setImages,
  onUpload,
  onDelete,
  loading
}) => {
  const classes = useStyles()

  const onDrop = useCallback((acceptedFiles: FileWithPath[]) => {
    setImages((currentImages) => [
      ...acceptedFiles.map((singleFile: FileWithPath) => ({
        file: singleFile,
        status: FileStatus.TYPING_NAME,
        fileName: singleFile.name,
        fileURL: URL.createObjectURL(singleFile),
        fileSize: singleFile.size,
        mediaID: ''
      })),
      ...currentImages
    ])
  }, [])

  const { getRootProps, getInputProps, isDragActive } = useDropzone({ onDrop })

  return (
    <Modal
      dir={getDirection()}
      open={isOpen}
      onClose={onClose}
      className={classes.modal}>
      <Slide in={isOpen} direction="down">
        <Paper className={classes.paper} elevation={4}>
          <div {...getRootProps()} className={classes.dropZone}>
            <input {...getInputProps()} />
            <img
              className={classes.icon}
              src={UploadIcon}
              alt="Upload Images"
            />
            {isDragActive ? (
              <p>{getTranslate('Drop the files here...')}</p>
            ) : (
              <p>
                {getTranslate(
                  'Drag & drop some files here, or click to select files'
                )}
              </p>
            )}
          </div>

          {loading ? (
            <ImageBoxSkeleton />
          ) : (
            images
              .slice(multi ? 0 : images.length - 1, images.length)
              .map((item, index) => {
                return (
                  <ImageBox
                    key={item.fileURL}
                    item={item}
                    onChange={(newImage: ImageProps) => {
                      setImages((currentImages) => [
                        ...currentImages.slice(0, index),
                        newImage,
                        ...currentImages.slice(index + 1)
                      ])
                    }}
                    imageType=""
                    onUpload={() => onUpload(item)}
                    onDelete={() => onDelete(item)}
                  />
                )
              })
          )}
          {/* <div className={classes.buttonContianer}>
            <Button color="primary" variant="contained" onClick={onClose}>
              {getTranslate('Close')}
            </Button>
          </div> */}
        </Paper>
      </Slide>
    </Modal>
  )
}
export default UploadFileModal
